import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
    TCITenantSelectorType
} from "@tci/common";
import { BaseAppDetailMenuComponentInput, BaseAppDetailMenuComponentOutput } from "../../ng-app-details/ng-app-details-menu";
import { NgToastrService } from "../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import { AbstractTCITenantComponent } from "../../ng-tenant/tci-tenant-component";
import { ITCIAppDetailsMenuOutput } from "../../ng-tenant/tci-tenant-components";
import { BaseAppHMShareExternallyService } from "./base-app-hm-share-externally.service";

@Component({
    selector: TCITenantSelectorType.TCI_APP_DETAIL_SHARE_EXTERNALLY.toString(),
    templateUrl: "./base-app-hm-share-externally.component.html",
    styleUrls: ["./base-app-hm-share-externally.component.less"]
})
export class BaseAppHMShareExternallyComponent<E, I extends BaseAppDetailMenuComponentInput,
    O extends BaseAppDetailMenuComponentOutput<ITCIAppDetailsMenuOutput>>
    extends AbstractTCITenantComponent<E, I, O>
    implements OnInit {

    constructor(
        protected shareExternallyService: BaseAppHMShareExternallyService,
        protected translate: TranslateService,
        protected toastr: NgToastrService) {
        super();
    }

    ngOnInit(): void { }

    shareExternally(): void {

    }

    cancel(): void {
        this.closeModal(false);
    }

    protected closeModal(refresh: boolean): ITCIAppDetailsMenuOutput {
        const e: ITCIAppDetailsMenuOutput = {
            menuItemSelector: this.input.componentSelector,
            closeModal: true,
            refresh
        };
        this.output.emit(e);
        return e;
    }
}
